import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Rob from "../views/Rob.vue";
import Carte from "../views/Carte.vue";
import User from "../views/User.vue";
import Login from "../views/LoginView.vue";
import Logout from "../views/Logout.vue";

import LoginView from "../views/LoginView.vue";
import AuthCallback from "../views/AuthCallback.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/carteachat/",
    name: "home",
    component: Home,
  },
  {
    path: "/carteachat/rob/:rob?/:structure?/:carte?/:ligne?/:nomCarte?/:nomStructure?/:centreFacturation?",
    name: "rob",
    component: Rob,
  },
  {
    path: "/carteachat/carte",
    name: "carte",
    component: Carte,
  },
  {
    path: "/carteachat/user",
    name: "user",
    component: User,
  },
  {
    path: "/carteachat/login",
    name: "login",
    component: Login,
  },

  {
    path: "/carteachat/loginView",
    name: "loginView",
    component: LoginView,
  },
  {
    path: "/carteachat/logout",
    name: "logout",
    component: Logout,
  },
  { path: "/auth/callback", component: AuthCallback }, // 🔥 Ajoute cette ligne
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
